/**
 * MODULE_ID constants for the application
 * These correspond to the IDs in the back-end database 'modules' table.
 */

export const MODULE_LP = 115
export const MODULE_CD = 112
export const MODULE_ACC = 117
export const MODULE_ARTICLES = 141
export const MODULE_CINEMA = 154
export const MODULE_MESSAGES = 157
export const MODULE_SHOP_VISITS = 161
export const MODULE_SALES = 142
export const MODULE_POSTHEAD = 167

// Module ID aliases for backward compatibility
export const ACC_ID = MODULE_ACC
export const SHOP_VISITS_ID = MODULE_SHOP_VISITS

/**
 * Groups of modules
 */
export const PRODUCT_MODULES = [MODULE_LP, MODULE_CD, MODULE_ACC]
export const LP_CD_MODULES = [MODULE_LP, MODULE_CD]

/**
 * Module identification helpers
 */
export const isProductModule = (id) => PRODUCT_MODULES.includes(Number(id))
export const isLpCdModule = (id) => LP_CD_MODULES.includes(Number(id))
export const isLpModule = (id) => Number(id) === MODULE_LP
export const isCdModule = (id) => Number(id) === MODULE_CD
export const isAccModule = (id) => Number(id) === MODULE_ACC
export const isMessagesModule = (id) => Number(id) === MODULE_MESSAGES
export const isArticlesModule = (id) => Number(id) === MODULE_ARTICLES
export const isCinemaModule = (id) => Number(id) === MODULE_CINEMA
export const isShopVisitsModule = (id) => Number(id) === MODULE_SHOP_VISITS
export const isSalesModule = (id) => Number(id) === MODULE_SALES

const READ_ONLY_MODULE_IDS = Object.freeze([149, MODULE_POSTHEAD])

export const isReadOnlyModule = (id) =>
  READ_ONLY_MODULE_IDS.includes(Number(id))
